import { defineStore } from 'pinia'
import { useRequest } from 'composables/useRequest.js'

const CACHE_TTL = 5 * 60 * 1000

export const useHolidaysStore = defineStore('holidays', {
  state: () => ({
    holidays: [],
    fetchedAt: null,
    loading: false,
    error: null,
  }),

  getters: {
    isCacheValid: (state) =>
      state.fetchedAt !== null && Date.now() - state.fetchedAt < CACHE_TTL,
  },

  actions: {
    async fetchIfStale() {
      if (this.isCacheValid) return
      await this.fetchHolidays()
    },

    async fetchHolidays() {
      this.loading = true
      this.error = null
      try {
        const { axiosRequest } = useRequest()
        const res = await axiosRequest('GET', '/api/v1/holidays', {}, false)
        if (!res.js_error && res.response.success) {
          this.holidays = res.response.data
          this.fetchedAt = Date.now()
        } else {
          this.error = 'Failed to load holidays.'
        }
      } catch {
        this.error = 'Something went wrong.'
      } finally {
        this.loading = false
      }
    },

    // Called after any mutation — the existing non-API endpoints return
    // the full updated list as a JSON string, so we parse and cache it here.
    setFromMutationResponse(holidaysJson) {
      this.holidays = JSON.parse(holidaysJson)
      this.fetchedAt = Date.now()
    },

    invalidate() {
      this.fetchedAt = null
    },
  },
})
